import { getFunctions, httpsCallable } from 'firebase/functions';
import { ExtendedError } from './error';

export function logError(error: Error | ExtendedError): void {
  const functions = getFunctions();
  const logError = httpsCallable(functions, 'logError');
  logError(error);
}
